<template>
    <span v-if="status === PayyoPaymentStatus.SUCCEEDED"
          class="label label-success">
        {{ l('PAYYO_STATUS_BADGE.SUCCEEDED') }}
    </span>
    <span v-else-if="status === PayyoPaymentStatus.FAILED"
          class="label label-danger">
        {{ l('PAYYO_STATUS_BADGE.FAILED') }}
    </span>
    <span v-else-if="status === PayyoPaymentStatus.CANCELED"
          class="label label-default">
        {{ l('PAYYO_STATUS_BADGE.CANCELLED') }}
    </span>
    <span v-else-if="status === PayyoPaymentStatus.PENDING"
          class="label label-warning">
        {{ l('PAYYO_STATUS_BADGE.PENDING') }}
    </span>
    <span v-else-if="status === PayyoPaymentStatus.REQUIRES_ACTION"
          class="label label-warning">
        {{ l('PAYYO_STATUS_BADGE.REQUIRES_ACTION') }}
    </span>
</template>

<script>
import PayyoPaymentStatus from '@/lib/PaymentMethods/Payyo/Enums/PayyoPaymentStatus';

// Please note: this is similar but not the same as the PayyoSimpleStatusBadge.
export default {
    name: 'PayyoRefundStatusBadge',

    props: {
        status: {
            type: String,
            default: null,
        },
    },

    computed: {
        PayyoPaymentStatus() {
            return PayyoPaymentStatus;
        },
    },
};

</script>
